"use strict";

function getGlobalZipCodeApiConfig() {
    if (typeof window === "undefined" || !window.AlgarZipCodeApi) {
        return null;
    }

    return window.AlgarZipCodeApi;
}

function isRecaptchaRequiredFlag(value) {
    if (value === true || value === 1) {
        return true;
    }

    return String(value || "").toLowerCase() === "true";
}

function resolveZipCodeRequestConfig(urlFromDom, isRecaptchaRequiredRaw) {
    const globalConfig = getGlobalZipCodeApiConfig();
    const isRecaptchaRequired = isRecaptchaRequiredFlag(
        (globalConfig && globalConfig.recaptchaRequired)
        || isRecaptchaRequiredRaw
    );

    let url = urlFromDom;

    if (isRecaptchaRequired && globalConfig && globalConfig.postUrl) {
        url = globalConfig.postUrl;
    } else if (!isRecaptchaRequired && globalConfig && globalConfig.getUrl) {
        url = globalConfig.getUrl;
    }

    if (isRecaptchaRequired && url && url.indexOf("GetAddressListByZipCode") !== -1) {
        url = url.replace("GetAddressListByZipCode", "PostAddressListByZipCode");
    }

    if (!url && globalConfig) {
        url = isRecaptchaRequired ? globalConfig.postUrl : globalConfig.getUrl;
    }

    return {
        url: url,
        isRecaptchaRequired: isRecaptchaRequired
    };
}

function readRecaptchaRequiredFromField($field) {
    if (!$field || !$field.length) {
        return "";
    }

    return $field.attr("data-recaptcha-required");
}

function buildZipCodeAjaxOptions(url, zipCodeValue, token, isRecaptchaRequired) {
    const usePostWithRecaptcha = Boolean(isRecaptchaRequired && token);

    if (usePostWithRecaptcha) {
        return {
            url: url,
            type: "POST",
            contentType: "application/x-www-form-urlencoded; charset=UTF-8",
            headers: {
                "X-Recaptcha-Token": token
            },
            data: {
                zipCode: zipCodeValue,
                recaptchaToken: token
            }
        };
    }

    const data = {
        zipCode: zipCodeValue
    };

    if (token) {
        data.recaptchaToken = token;
    }

    return {
        url: url,
        type: "GET",
        contentType: "application/x-www-form-urlencoded",
        data: data
    };
}

function requestZipCodeAddress(options) {
    const globalConfig        = getGlobalZipCodeApiConfig();
    const resolvedConfig      = resolveZipCodeRequestConfig(options.url, options.isRecaptchaRequired);
    const url                 = resolvedConfig.url;
    const isRecaptchaRequired = resolvedConfig.isRecaptchaRequired;

    if (globalConfig && globalConfig.recaptchaSiteKey && !window.recaptchaSiteKey) {
        window.recaptchaSiteKey = globalConfig.recaptchaSiteKey;
    }

    if (
        isRecaptchaRequired
        && globalConfig
        && typeof globalConfig.requestAddress === "function"
    ) {
        globalConfig.requestAddress({
            zipCodeValue: options.zipCodeValue,
            onSuccess: options.onSuccess,
            onError: options.onError,
            onRecaptchaUnavailable: options.onRecaptchaUnavailable
        });

        return;
    }

    const executeRequest = function (token) {
        if (isRecaptchaRequired && !token) {
            if (options.onRecaptchaUnavailable) {
                options.onRecaptchaUnavailable();
            }

            return;
        }

        const ajaxOptions = buildZipCodeAjaxOptions(
            url,
            options.zipCodeValue,
            token,
            isRecaptchaRequired
        );

        ajaxOptions.success = options.onSuccess;
        ajaxOptions.error   = options.onError;

        $.ajax(ajaxOptions);
    };

    if (!isRecaptchaRequired) {
        executeRequest(null);
        return;
    }

    if (typeof window.grecaptcha === "undefined" || !window.recaptchaSiteKey) {
        if (options.onRecaptchaUnavailable) {
            options.onRecaptchaUnavailable();
        }

        return;
    }

    window.grecaptcha.ready(function () {
        window.grecaptcha.execute(window.recaptchaSiteKey, { action: "submit" })
            .then(executeRequest)
            .catch(function () {
                if (options.onRecaptchaUnavailable) {
                    options.onRecaptchaUnavailable();
                }
            });
    });
}

module.exports = {
    resolveZipCodeRequestConfig: resolveZipCodeRequestConfig,
    readRecaptchaRequiredFromField: readRecaptchaRequiredFromField,
    requestZipCodeAddress: requestZipCodeAddress
};
